export const SIZE_GRID = 'SizeGrid';
//# sourceMappingURL=size-grid.js.map